export const UPLOAD_RESUME_PENDING = "UPLOAD_RESUME_PENDING";
export const UPLOAD_RESUME_SUCCESS = "UPLOAD_RESUME_SUCCESS";
export const UPLOAD_RESUME_ERROR = "UPLOAD_RESUME_ERROR";

export const GET_RESUME_PENDING = "GET_RESUME_PENDING";
export const GET_RESUME_SUCCESS = "GET_RESUME_SUCCESS";
export const GET_RESUME_ERROR = "GET_RESUME_ERROR";

export const DELETE_RESUME_PENDING = "DELETE_RESUME_PENDING";
export const DELETE_RESUME_SUCCESS = "DELETE_RESUME_SUCCESS";
export const DELETE_RESUME_ERROR = "DELETE_RESUME_ERROR";

export const uploadResumePending = () => {
  return { type: UPLOAD_RESUME_PENDING };
};

export const uploadResumeSuccess = (payload) => {
  return { type: UPLOAD_RESUME_SUCCESS, payload };
};

export const uploadResumeError = (message) => {
  return { type: UPLOAD_RESUME_ERROR, message };
};

export const getResumePending = () => {
  return { type: GET_RESUME_PENDING };
};

export const getResumeSuccess = (payload) => {
  return { type: GET_RESUME_SUCCESS, payload };
};

export const getResumeError = (message) => {
  return { type: GET_RESUME_ERROR, message };
};

export const deleteResumePending = () => {
  return { type: DELETE_RESUME_PENDING };
};

export const deleteResumeSuccess = (payload) => {
  return { type: DELETE_RESUME_SUCCESS, payload };
};

export const deleteResumeError = (message) => {
  return { type: DELETE_RESUME_ERROR, message };
};

